import stls from '@f_qwep/styles/component/price/Price.module.sass';

export function CellDate({ info }: any) {
    return <p className={stls.cellDate}>{info.row.original.lastUpdated?.replace('T', ' ').split('.')[0]}</p>;
}
